import * as React from "react";
import { CampaignEmailApiModel } from "../apiModels/CampaignEmailApiModel";
import * as Noty from "noty";
import { ErrorModal } from "./ErrorModal";
import { HttpErrorHelper } from "../helpers/HttpErrorHelper";
import { RioLoadingIndicator, RioIf, RioAutoCompleteResult, RioInput, RioValidator, RioResources, RioIconButton, RioApiPost, RioApiGet, RioExpandingPanel, RioModal} from "rio.react.all";
import { AutoComplete } from "../components/AutoComplete";


interface ITestCampaignEmailModalProps {
    emailContent: string;
    emailSubject: string;
    campaignID: number;
    onClose: () => void;
}

interface ITestCampaignEmailModalState {
    toAddress: string;
    customerAccountNo: string;
    responseError: string;
    sending: boolean;
    customersWithReserves: Array<CustomerApiModel>
}

export class TestCampaignEmailModal extends React.Component<ITestCampaignEmailModalProps, ITestCampaignEmailModalState> {
    constructor(props: Readonly<ITestCampaignEmailModalProps>) {
        super(props);

        this.state = {
            toAddress: "",
            customerAccountNo: "",
            responseError: null,
            sending: false,
            customersWithReserves: []
        }
    }

    private validator = new RioValidator();

    render() {
        return (
            <React.Fragment>
                <RioModal visible={true} onCancel={() => this.handleCancelClicked()} backgroundClickDisabled={true}>

                    <RioExpandingPanel resource={RioResources.find("SendTestEmail")} className="sendTestEmailPanel" expandedDefault={true} disableToggle={true}>
                        <div>
                            <div>
                                <div className="form-row">
                                    <label className="emailTitleLabel">{RioResources.find("EmailAddress").text}<span className="required">*</span></label>
                                    <RioInput name="toAddress" type="text" className="emailTitleInput" value={this.state.toAddress} onChange={(e) => this.setState({ toAddress: e.target.value })} validator={this.validator} validations={{ required: true }} />
                                </div>
                            </div>
                            <div>
                                <div className="form-row">
                                    <label className="emailTitleLabel">{RioResources.find("Customer").text}<span className="required">*</span></label>
                                    <AutoComplete
                                        value={this.state.customerAccountNo}
                                        onValueChanged={value => this.setState({ customerAccountNo: value })}
                                        onGetOptions={text => this.getCustomerOptions(text)}
                                        onGetText={(accountNo) => this.handleGetTextForCustomer(accountNo)}
                                        suggestionMinimumChars={3}
                                    />
                                </div>
                            </div>
                            <RioIf condition={this.state.sending} then={
                                <div>
                                    <div className="form-row">
                                        <RioLoadingIndicator />
                                    </div>
                                </div>
                            } />
                        </div>

                    </RioExpandingPanel>

                    <div className="buttons emailComposerButtons">
                        <RioIconButton resource={RioResources.find("Send")} onClick={() => this.handleSendClicked()} hasPermission={true} />
                        <RioIconButton resource={RioResources.find("Cancel")} onClick={() => this.handleCancelClicked()} hasPermission={true} />
                    </div>

                    

                    <RioIf condition={!!this.state.responseError} then={
                        <ErrorModal text={this.state.responseError} onErrorModalClosed={() => this.setState({ responseError: null })} />
                    } />

                </RioModal>

            </React.Fragment>
        );
    }

    componentDidMount(): void {
        this.getCustomerReserves();
    }

    handleCancelClicked() {
        this.props.onClose();
    }

    handleSendClicked() {
        if (this.validator.isValid(this)) {
            var testEmail = new CampaignEmailApiModel;
            testEmail.emailContent = this.props.emailContent;
            testEmail.campaignTitle = this.props.emailSubject;
            testEmail.sentToEmail = this.state.toAddress;
            testEmail.customerNo = this.state.customerAccountNo;
            testEmail.campaignID = this.props.campaignID;

            RioApiPost.asPromise("/api/CampaignEmail/TestEmail", testEmail)
                .then(() => {
                    if (!!Response) {
                        new Noty({
                            type: "success",
                            layout: "topCenter",
                            theme: "relax",
                            text: "<span class='notyIcon'>" + RioResources.find("EmailSent").image + "</span> " + RioResources.find("EmailSent").text,
                            timeout: 3000,
                            closeWith: ['click']
                        }).show();
                        this.props.onClose();
                    }

                })
                .catch((response) => {
                    var error = HttpErrorHelper.handleHttpError(response, this, this.validator); //handles validator errors if validator passed
                    this.setState({ responseError: error, sending: false });
                });;
            this.setState({
                sending: true
            });
        }
    }


    handleGetTextForCustomer(accountNo: string): Promise<string> {
        return new Promise<string>((resolve, reject) => {
            if (!!accountNo) {
                var call = new RioApiGet<CustomerApiModel>(`/api/Customer/Get/${accountNo}`);
                call.onDone = response => {
                    if (response.success) {
                        resolve(response.item.accountNo + " - " + response.item.name);
                    } else {
                        reject();
                    }
                }
                call.send();
            }
        });
    }

    getCustomerOptions(prefix: string) {
        return new Promise<Array<RioAutoCompleteResult>>((resolve, reject) => {
            const results: Array<RioAutoCompleteResult> = [];
            if (prefix.length > 0) {
                this.state.customersWithReserves.forEach(customer => {
                    if (customer != null && customer.accountNo != null && customer.name != null) {
                        if (customer.accountNo.toLowerCase().includes(prefix.toLowerCase()) || customer.name.toLowerCase().includes(prefix.toLowerCase())) {
                            const item = new RioAutoCompleteResult();
                            item.value = customer.accountNo;
                            item.label = `${customer.accountNo} - ${customer.name}`;
                            if (customer.optOutEmail) {
                                item.label += RioResources.find("CustomerSelectOiptOutSuffix").text;
                            }
                            results.push(item);
                        }
                    }
                });
                resolve(results);
            }
        });
    }

    getCustomerReserves() {
        RioApiGet.asPromise<Array<CustomerApiModel>>("/api/Customer/GetCustomersWithReserves")
            .then(response => {
                this.setState({
                    customersWithReserves: response
                });
            })
            .catch((response) => {
                var error = HttpErrorHelper.handleHttpError(response, this, this.validator); //handles validator errors if validator passed
                this.setState({ responseError: error });
            });
    }
}